var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDHeatingThrottlingCircuit = function SvgDHeatingThrottlingCircuit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 632.99,
    y: 382,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.94,
    y: 395,
    width: 10.01,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "630.85 382.51 645.13 382.5 638 394.99 630.85 382.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.27,383l-6.27,10.98-6.29-10.98h12.56M645.99,382h-16s8.02,14,8.02,14l7.99-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "630.85 409.5 638 397.01 645.14 409.5 630.85 409.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638,398.01l6.27,10.99h-12.56l6.29-10.99M638,396l-8.02,14h16.01l-8-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 659,
    cy: 396,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,386c5.52,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M659,385c-6.08,0-11,4.92-11,11s4.93,11,11,11,11-4.92,11-11-4.93-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M661.92,392.65v5.69h-.98v-1.88s.1-2.5.1-2.5l-1.68,4.38h-.71s-1.68-4.38-1.68-4.38l.1,2.51v1.88h-.98v-5.69h1.28s1.64,4.36,1.64,4.36l1.64-4.36h1.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 426,
    r: 14,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624,426c0-7.67-6.16-13.88-13.81-13.99-.03,0-.05,0-.08,0-.04,0-.07,0-.11,0-7.73,0-14,6.27-14,14s6.27,14,14,14c.04,0,.07,0,.11,0,.01,0,.02,0,.03,0,.02,0,.03,0,.05-.01,7.64-.1,13.81-6.32,13.81-13.99ZM622.95,424.93l-11.54-11.85c6.16.66,11.03,5.64,11.54,11.85ZM597,426c0-7.15,5.8-12.96,12.93-13l12.66,13-12.66,13c-7.14-.04-12.93-5.85-12.93-13ZM611.4,438.92l11.54-11.85c-.51,6.2-5.39,11.18-11.54,11.85Z"
  })))));
};
export default SvgDHeatingThrottlingCircuit;